import { OffersCombinedApiClient } from '@fourthwall/services/dist/OffersCombinedApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useCombinedOfferArchivedMutation = createMutationHook(
  OffersCombinedApiClient.deleteOfferCombined,
  {
    mutationKey: ['deleteOfferCombined'],
  },
)
